<style lang="stylus">
    .downloadpc-modal
        position absolute
        right 64px
        bottom 48px
        z-index 100
        width 304px
        padding 0 24px 24px 24px
        box-shadow: 0px 15px 30px 0px rgba(0, 0, 0, 0.15);
        background #fff
        border-radius 8px
        &:after
            content ""
            position absolute
            left 0
            top 0
            width 100%
            height 100%
            border 1px solid rgba(0, 0, 0, 0.05)
            pointer-events none
            border-radius 8px
        .titlebox
            height 40px
            margin-bottom 8px
            p
                font-size 14px
                color #000
                font-weight 700
                line-height 40px
            .title-icon
                color #222
                position absolute
                top 8px
                right 8px
                width 24px
                height 24px
                cursor pointer
                border-radius 6px
                &:hover
                    background rgba(0, 0, 0, 0.06)
                >svg
                    position absolute
                    top 50%
                    left 50%
                    transform translate(-50%, -50%)
                    stroke $modal-title-textcolor
                    width 16px
                    height 16px
        .content
            font-size 14px
            line-height 20px
            color #222
            margin-bottom 24px
        .downloadbtn
            display flex
            justify-content center
            align-items center
            width 100%
            height 28px
            border-radius 6px
            background #017fff
            cursor pointer
            &:hover
                background #0177f0
            span
                font-size 11px
                color #fff
</style>

<template>
    <div class="downloadpc-modal">
        <div class="titlebox">
            <p>{{ $t("remind") }}</p>
            <div class="title-icon" @click="handleClose">
                <iconSymbol name="Del" />
            </div>
        </div>
        <p class="content">{{ $t("content") }}</p>
        <div class="downloadbtn" @click="toDownload">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.5 5.51367V10.0005V13.7505" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                <path
                    d="M4.5 12.5V16C4.5 16.8284 5.17157 17.5 6 17.5H17C17.8284 17.5 18.5 16.8284 18.5 16V12.5"
                    stroke="white"
                    stroke-linecap="round"
                />
                <path
                    d="M13.5749 12H9.42712C9.25753 12 9.16491 12.1978 9.2735 12.3281L11.3474 14.8157C11.4273 14.9116 11.5747 14.9116 11.6546 14.8157L13.7285 12.3281C13.8371 12.1978 13.7445 12 13.5749 12Z"
                    fill="white"
                />
            </svg>
            <span>{{ $t("download") }}</span>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import { downloadPC } from "@/public/utils/tool.js";

    @Component
    export default class DownloadTips extends Vue {
        handleClose() {
            this.$emit("closeDownloadTips");
        }
        toDownload() {
            downloadPC(this.internal, this.lang);
            this.sensors.track("downloadTips_click", {
                Catalogues: "downloadEdrawmaxTips",
                click_source: "editPage",
            });
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "remind": "提示",
        "content": "10W+流程图、结构图等专业模板，小白也能制作专业图示。下载客户端，更多功能等你来用！",
        "download": "免费下载"
    },
    "en": {
        "remind": "Reminder",
        "content": "Download EdrawMax for a more professional, smooth, and stable drawing experience",
        "download": "Try It Free"
    },
    "fr": {
        "remind": "Rappeler",
        "content": "Téléchargez EdrawMax pour une expérience de dessin plus professionnelle, fluide et stable",
        "download": "Essai gratuit"
    },
    "de": {
        "remind": "Hinweis",
        "content": "EdrawMax herunterladen, um ein professionelleres, reibungsloses und stabileres Zeichenerlebnis zu erhalten.",
        "download": "Gratis Testen"
    },
    "jp": {
        "remind": "通知",
        "content": "EdrawMaxをダウンロードして、よりプロフェッショナルな、スムーズで安定した描画体験を実現",
        "download": "無料で試す"
    },
    "es": {
        "remind": "Recordatorio",
        "content": "Descarga EdrawMax para disfrutar de una experiencia de dibujo más profesional, fluida y estable",
        "download": "Probarlo gratis"
    },
    "pt": {
        "remind": "Alerta",
        "content": "Baixe EdrawMax para uma experiência de desenho mais profissional, suave e estável",
        "download": "Teste Grátis"
    },
    "it": {
        "remind": "Promemoria",
        "content": "Scarica EdrawMax per un'esperienza di disegno più professionale, fluida e stabile",
        "download": "Prova gratis"
    }
}
</i18n>
